import type { TooltipProps as MUITooltipProps } from '@mui/material/Tooltip';
import Tooltip from '@mui/material/Tooltip';

export default function MUITooltip({
  children,
  placement = 'top',
  ...props
}: Readonly<MUITooltipProps>) {
  return (
    <Tooltip {...props} placement={placement}>
      {children}
    </Tooltip>
  );
}
